import { getFetch } from "../../utils/fetch";

async function getChartData() {
  const data = await getFetch("/Chart");

  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}


async function getChartDataLicense(startDate = null, endDate = null) {
  const data = await getFetch(`/Chart/ReportChart?start=${startDate}&end=${endDate}`);

  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}


async function getDashboardReport() {
  const data = await getFetch("/DashboardReport");

  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function getDashboardLicenseReport(startDate = null, endDate = null) {
  const data = await getFetch(`/DashboardReportLicense?start=${startDate}&end=${endDate}`);

  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
export { getChartData,getDashboardReport,getChartDataLicense,getDashboardLicenseReport };
